/**
 * Phone helpers for BR UI mask `+55 (##) #####-####`.
 * Backend stores E.164 (+55…); the mask expects national digits only.
 */

/** National digits (DDD + number, max 11) for PatternFormat phone fields. */
export function toBrazilPhoneMaskInput(phone?: string | null): string {
  if (!phone?.trim()) return '';

  const trimmed = phone.trim();
  const hasPlus = trimmed.startsWith('+');
  let digits = trimmed.replace(/\D/g, '');

  // Strip country code 55 when value is E.164 (+55…) or longer than national length.
  // Do not strip when length === 11 and DDD is 55 (RS) without a leading +.
  if (hasPlus && digits.startsWith('55')) {
    digits = digits.slice(2);
  } else if (digits.length > 11 && digits.startsWith('55')) {
    digits = digits.slice(2);
  }

  return digits.slice(0, 11);
}

/** E.164 (+55…) for API writes, or null if empty. */
export function toBrazilPhoneE164(phone?: string | null): string | null {
  const national = toBrazilPhoneMaskInput(phone);
  if (!national) return null;
  return `+55${national}`;
}

/** Digits-only CPF (11) for storage / lookups. */
export function normalizeCpfDigits(cpf?: string | null): string | null {
  if (!cpf?.trim()) return null;
  const digits = cpf.replace(/\D/g, '').slice(0, 11);
  return digits.length === 11 ? digits : null;
}

/** Digits/alphanumeric without punctuation (IE / IM / CM). */
export function normalizeAlnumId(value?: string | null): string | null {
  if (!value?.trim()) return null;
  const cleaned = value.replace(/[^0-9A-Za-z]/gi, '').toUpperCase();
  return cleaned || null;
}

/** CEP 8 digits. */
export function normalizeZipDigits(zip?: string | null): string | null {
  if (!zip?.trim()) return null;
  const digits = zip.replace(/\D/g, '').slice(0, 8);
  return digits.length === 8 ? digits : null;
}
